/**
 * Typed environment variables for the landing page.
 * VITE_API_URL must be set in .env.production before building.
 */
export const env = {
  apiUrl: import.meta.env.VITE_API_URL as string,
} as const;
